<template>
  <v-container class="pa-0">
    <!--app-view-toolbar-->
    <app-view-toolbar :title="headline" :showBackButton="true" :isEdit="true"></app-view-toolbar>
    <template v-if="viewDataIsLoaded">
      <v-form ref="formEdit" onSubmit="return false">
        <v-row class="ph-12 pb-6">
          <v-col>
            <v-text-field
              v-if="isNew"
              type="text"
              v-model="fortnoxNumberSearched"
              label="Sök på Fortnox artikelnummer"
              outlined
              color="secondary"
              class="pt-0"
              @keydown.enter="searchFortnoxArticle()"
            ></v-text-field>
            <template
              v-if="articleStatus == 'notFound'"
            >
              <div class="text-body-1">Ingen artikel hittades i Fortnox</div>
            </template>
            <template
              v-else-if="articleStatus == 'found' || articleStatus == 'existing'"
            >
              <div class="text-h6 mb-4">{{ viewData.farData.number }} - {{ viewData.farData.name }}</div>
              <p>Avgiftstyp</p>
              <v-radio-group
                v-model="viewData.farData.far_id_fam"
                column
              >
                <v-radio
                  v-for="famData in viewData.famData_ar"
                  :key="famData.f_id"
                  :label="famData.f_name"
                  :value="famData.f_id"
                  :rules="[formRules.checked(viewData.farData.far_id_fam)]"
                  validate-on-blur
                  required
                ></v-radio>
              </v-radio-group>
              <template
                v-if="viewData.farData.far_id_fam == 2"
              >
                <!--assigned assigment qty from-->
                <v-text-field
                  type="number"
                  v-model="viewData.farData.far_int_assigned_assignment_qty_from"
                  label="Fr o m antal dagar"
                  outlined
                  color="secondary"
                  class="pt-0"
                  :rules="viewData.farData.far_id_fam == 2 ? [formRules.required, formRules.positiveInteger(viewData.farData.far_int_assigned_assignment_qty_from)] : []"
                  validate-on-blur
                ></v-text-field>
                <div class="text-caption">
                  Vid fakturering, räknas summan ut beroende på dagslängde för resp. tilldelat jobb per åkeri. Den kopplade artikeln vars gränsvärde för antal dagar är exakt lika med jobbets, eller ligger närmast under, kommer användas. 
                  <br>
                  <br>
                  Exempel: Om ett åkeri har 2 tilldelade jobb en månad, ett på 1 dag och ett på 4 dagar, och det finns tre artiklar upplagda. En med gränsvärde 1, en med 3 och en med 10, så kommmer artikeln med gränsvärde 1 att användas till 1-dagasjobbet och artikeln med gränsvärde 3 användas på 4-dagarsjobbet.
                </div>
              </template>
            </template>
          </v-col>
        </v-row>
      </v-form>
    </template>
    <!--app-form-bottom-->
    <app-form-bottom
      v-if="isSavable"
      :viewDataIsLoaded="viewDataIsLoaded"
      :postWasInvalid="postWasInvalid"
      :errorOutput="errorOutput"
      @onSubmit="doSubmit"
      @onErrorOk="postWasInvalid = false"
      submitText="Koppla"
      :loader="loader"
      :removable="!isNew"
      @onRemoveDialogOpen="removeDialog = true"
      @onRemoveDialogClose="removeDialog = false"
      @onRemove="remove"
      txtRemoveDialogButton="Frånkoppla"
      txtRemoveDialogTitle="Frånkoppla artikel"
      txtRemoveDialogText="Vill du verkligen frånkoppla artikeln?"
      :removeDialog="removeDialog"
    ></app-form-bottom>
    <!--snack-bar-->
    <app-snack-bar></app-snack-bar>
  </v-container>
</template>

<script>
import axios from 'axios'
import SnackBar from '../components/SnackBar'
import ViewToolbar from '../components/ViewToolbar'
import FormBottom from '../components/FormBottom'
import { generalMixin } from '../mixins/general'
import { urlMixin } from '../mixins/url'
import { adminMixin } from '../mixins/admin'
import { snackBarBus } from '../main'
import { mapGetters } from 'vuex'

export default {
  name: 'AdminFortnox',
  components: {
    'app-snack-bar': SnackBar,
    'app-view-toolbar': ViewToolbar,
    'app-form-bottom': FormBottom,
  },
  mixins: [generalMixin, urlMixin, adminMixin],
  props: {
    uuid: {//is articleNumber in this case
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      viewData: {},
      viewDataIsLoaded: false,
      fortnoxNumberSearched: '',
      fortnoxNumberToSave: '',
      postWasInvalid: false,
      errorOutput: '',
      removeDialog: false,
      loader: true,
    }
  },
  computed: {
    ...mapGetters(['access_token', 'loggedInData']),
    headline() {
      return this.isNew ? 'Koppla ny artikel' : 'Kopplad artikel'
    },
    isNew() {
      return this.uuid == '___new'
    },
    articleStatus() {
      return this.viewDataIsLoaded ? this.viewData.articleStatus : ''
    },
    isSavable() {
      return this.articleStatus == 'found' || this.articleStatus == 'existing'
    }
  },
  methods: {
    onViewData(viewData) {
      this.viewData = viewData
      this.viewDataIsLoaded = true
    },
    searchFortnoxArticle() {
      this.fortnoxNumberToSave = this.fortnoxNumberSearched.trim()
      if (!this.fortnoxNumberToSave.length) {
        return
      }
      //get view data
      let config = {
        headers: {
          'Authorization': this.access_token
        }
      }
      let queryStringData_ar = [
        {
          name: 'articleNumber'
          ,value: this.fortnoxNumberToSave
        }
      ]
      let url = this.url_composeApiUrl('/admin/search-fortnox-article', queryStringData_ar)
      console.log('get', url)
      axios.get(url, config)
        .then(response => {
          console.log('response', response)
          if (response.data.success) {
            //success
            //reset viewData.farData
            this.viewData.farData = response.data.returnData.farData
            this.viewData.articleStatus = response.data.returnData.articleStatus
          } else if (this.onNonSuccessApiCall(response.data.returnData)) {
            snackBarBus.$emit('message', this.generalParseErrorArray(response.data.returnData.error_ar))
          }
        })
        .catch(error => {
          snackBarBus.$emit('message', error.toString())
        })
    },
    doSubmit() {
      const formIsValid = this.$refs.formEdit.validate()
      if (!formIsValid) {
        snackBarBus.$emit('message', 'Formuläret ej komplett ifyllt')
        return
      }
      this.loader = true
      //post data to API
      let postData = {
        farData: this.viewData.farData
      }
      //set config for axios request with Authorization header
      let config = {
        headers: {
          'Authorization': this.access_token
        }
      }
      let url = this.url_composeApiUrl('/admin/save-fortnox-article/' + this.fortnoxNumberToSave)
      console.log('put url: ' + url, postData)
      axios.put(url, postData, config)
        .then(response => {
          console.log('put response', response)
          this.loader = false
          if (response.data.success) {
            //success - return to list
            this.$router.replace({ name: 'admin-fortnox'})
          } else if (this.onNonSuccessApiCall(response.data.returnData)) {
            this.errorOutput = this.generalParseErrorArray(response.data.returnData.error_ar)
            this.postWasInvalid = true
          }
        })
        .catch(error => {
          this.loader = false
          snackBarBus.$emit('message', error.toString())
          this.postWasInvalid = true
        })
    },
    remove() {
      //hide dialog
      this.removeDialog = false
      //show loader
      this.loader = true
      //set config for axios request with Authorization header
      let config = {
        headers: {
          'Authorization': this.access_token
        }
      }
      let url = this.url_composeApiUrl('/admin/remove-fortnox-article/' + this.uuid)
      axios.delete(url, config)
        .then(response => {
          console.log('delete response', response)
          this.loader = false
          if (response.data.success) {
            //success - return to list
            this.$router.replace({ name: 'admin-fortnox'})
          } else if (this.onNonSuccessApiCall(response.data.returnData)) {
            //still logged in
            this.errorOutput = this.generalParseErrorArray(response.data.returnData.error_ar)
          }
        })
        .catch(error => {
          this.loader = false
          snackBarBus.$emit('message', error.toString())
        })
    },
  },
  created() {
    if (!this.isNew) {
      this.fortnoxNumberToSave = this.uuid
    }
    //get view data
    let config = {
      headers: {
        'Authorization': this.access_token
      }
    }
    let url = this.url_composeApiUrl('/admin/fortnox-article/' + this.uuid)
    console.log('get', url)
    axios.get(url, config)
      .then(response => {
        console.log('response', response)
        this.loader = false
        if (response.data.success) {
          //success
          this.onViewData(response.data.returnData.viewData)
        } else if (this.onNonSuccessApiCall(response.data.returnData)) {
          snackBarBus.$emit('message', this.generalParseErrorArray(response.data.returnData.error_ar))
        }
      })
      .catch(error => {
        this.loader = false
        snackBarBus.$emit('message', error.toString())
      })
  }
}
</script>
<style>
</style>